<template>
  <div class="form-group mb-3 text-left">
    <label v-if="label" :class="{ 'text-danger': hasError }">
      {{ label }}
    </label>
    
    <div class="position-relative">
      <textarea
        :class="[
          inputClass, 
          'form-control custom-textarea shadow_inset_sm', 
          { 'is-invalid': hasError, 'has-counter': maxLength }
        ]"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :maxlength="maxLength"
        v-bind="$attrs"
        @input="onInput"
        @keyup.enter="onEnter"
        @blur="onBlur"
      ></textarea>
      
      <div v-if="maxLength" class="char-counter">
        {{ currentLength }}/{{ maxLength }}
      </div>
    </div>
    
    <small v-if="hasError" class="form-text text-danger">
      {{ errorMessage }}
    </small>
  </div>
</template>

<script>
/**
 * /--------------------------/
 * COMPONENTE: TextAreaProvider 
 * /--------------------------/
 * 
 * Este Componente es un TextArea modularizado que soporta:
 * - Contador de caracteres opcional (vía maxLength)
 * - Estilo consistente con InputProvider
 * - Manejo de errores
 */
export default {
  name: 'TextAreaProvider',
  props: {
    // Texto del label
    label: { 
      type: String, 
      default: '' 
    },
    // Valor para v-model
    value: { 
      type: [String, Number], 
      default: '' 
    },
    // Placeholder informativo
    placeholder: { 
      type: String, 
      default: '' 
    },
    // Clases adicionales
    inputClass: { 
      type: [String, Object, Array], 
      default: '' 
    },
    // Atributos de estado
    disabled: { 
      type: Boolean, 
      default: false 
    },
    readonly: { 
      type: Boolean, 
      default: false 
    },
    // Límite de caracteres (activa contador)
    maxLength: {
      type: [Number, String],
      default: null
    },
    // Control de errores
    hasError: { 
      type: Boolean, 
      default: false 
    },
    errorMessage: { 
      type: String, 
      default: '' 
    }
  },
  computed: {
    currentLength() {
      return this.value ? this.value.toString().length : 0;
    }
  },
  methods: {
    /**
     * Emite el valor al padre para mantener el v-model sincronizado
     */
    onInput(event) {
      this.$emit('input', event.target.value);
    },

    /**
     * Emite el evento cuando se presiona la tecla Enter
     */
    onEnter(event) {
      this.$emit('enter', event.target.value);
    },

    /**
     * Emite el evento cuando el textarea pierde el foco
     */
    onBlur(event) {
      this.$emit('blur', event.target.value);
    }
  },
  inheritAttrs: false
}
</script>

<style scoped>
  .custom-textarea {
    border: 1px solid #89898995;
    border-radius: 20px !important;
    padding: 12px 15px !important;
    min-height: 80px;
    background-color: transparent !important;
    color: #45505e !important;
    resize: none;
  }

  .custom-textarea.has-counter {
    padding-bottom: 28px !important;
  }

  .custom-textarea:focus {
    outline: none;
    box-shadow: none;
  }

  .char-counter {
    position: absolute;
    bottom: 10px;
    right: 15px;
    font-size: 11px;
    color: #898989;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 2px 6px;
    border-radius: 10px;
    pointer-events: none;
  }
</style>
